(function (upp) {
    'use strict';

    /**
     * @enum {string}
     */
    var CustomerFieldType = {
        TEXT: 'TEXT',
        EMAIL: 'EMAIL',
        PASSWORD: 'PASSWORD',
        PHONE: 'PHONE',
        OPTIONS: 'OPTIONS',
        DATE: 'DATE',
    }

    upp.constant('customerFieldType', CustomerFieldType)
})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/customer-account/services/customer-field-type.service.js